import * as React from 'react'

import { REQUEST_STATUS_BADGE_CONFIG } from '@ps/common-features/constants/requestStatusBadge'
import { Badge } from '@ps/ds/components/primitives/Badge/Badge'

type RequestStatusBadgeProps = React.PropsWithChildren<{
  status: keyof typeof REQUEST_STATUS_BADGE_CONFIG
}>

export const RequestStatusBadge: React.FC<RequestStatusBadgeProps> = ({ status, children }) => {
  const config = REQUEST_STATUS_BADGE_CONFIG[status]
  return (
    <Badge icon={config.icon} variant={config.variant} size="sm" rounded>
      {children}
    </Badge>
  )
}
